<script lang="ts">
import type { Writable } from 'svelte/store';

import { clickOutside, Icon } from '@viamrobotics/prime-core';

import { popupEnter } from '$lib/components/floating/popup-enter';

export let label: string;
export let isOpen: Writable<boolean>;
export let showIndicator = false;

const closeMenu = () => isOpen.set(false);
const toggleMenu = () => isOpen.update((value) => !value);
</script>

<!-- the font-public-sans class below may be load-bearing. removing it
 may have caused e2e tests to flake -->
<div
  class="relative z-max flex items-center font-public-sans"
  use:clickOutside={closeMenu}
>
  <button
    aria-label={label}
    on:click={toggleMenu}
    class={`flex h-[34px] items-center justify-between gap-1.5 whitespace-nowrap px-2 font-medium ${
      $isOpen ? 'bg-ghost-light' : 'hover:bg-ghost-light'
    }`}
  >
    <slot name="button-text" />
    {#if showIndicator}
      <div class={`transition duration-200 ${$isOpen ? 'rotate-180' : ''}`}>
        <Icon
          name="chevron-down"
          class="text-gray-7 w-4 h-4"
        />
      </div>
    {/if}
  </button>
  {#if $isOpen}
    <article
      use:popupEnter
      class="absolute right-0 top-full z-max -mr-1 mt-4 flex max-h-[80vh] w-80 origin-top-right flex-col items-stretch overflow-y-auto border border-medium bg-white text-default shadow-sm"
    >
      <slot />
    </article>
  {/if}
</div>
